import React from "react";
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
} from "react-admin";
// Local
import { caption } from "../../components";

const EditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const AppraisalDealTypeCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="list" toolbar={<EditToolbar />}>
      <ReferenceInput source="dealerId" reference="dealers" autoFocus fullWidth>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" fullWidth />
      <ReferenceInput
        source="appraisalTypeId"
        reference="lists/appraisal_types"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      {caption(`Appraisal type is not in use at this time.`)}
    </SimpleForm>
  </Create>
);

export default AppraisalDealTypeCreate;
